import { render, staticRenderFns } from "./CalcList.vue?vue&type=template&id=13d7f922&scoped=true&"
import script from "./CalcList.vue?vue&type=script&lang=ts&"
export * from "./CalcList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7f922",
  null
  
)

export default component.exports